import { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Paperclip, History, CalendarOff } from "lucide-react";
import { http, formatApiError } from "../../lib/api";
import { useRealtime } from "../../context/RealtimeContext";
import { AbsStatus, frd } from "./common";
import { AbsenceActions, UnassignedNotice, openAbsenceFile, ABS_ACTIONS } from "./AgentAbsencesPanel";

const FILTERS = [["pending", "En attente"], ["approved,rejected,cancelled", "Traitées"]];

export const AgentRequestsInbox = () => {
  const [f, setF] = useState("pending");
  const [items, setItems] = useState(null);
  const [un, setUn] = useState(null);
  const [err, setErr] = useState("");
  const gen = useRef(0);
  const { lastEvent } = useRealtime();
  const load = useCallback(() => {
    const g = ++gen.current;
    return http.get("/absences", { params: { status: f } })
      .then((r) => { if (g !== gen.current) return; setErr(""); setItems(f === "pending" ? r.data : [...r.data].sort((a, b) => (b.decided_at || b.cancelled_at || b.created_at).localeCompare(a.decided_at || a.cancelled_at || a.created_at)).slice(0, 100)); })
      .catch((e) => { if (g === gen.current) setErr(formatApiError(e)); });
  }, [f]);
  useEffect(() => { setItems(null); load(); }, [load]);
  useEffect(() => { if (lastEvent?.event === "absence_changed") load(); }, [lastEvent, load]);
  return (
    <div className="space-y-3" data-testid="agent-requests-inbox">
      <div className="flex items-center gap-2">
        <CalendarOff className="h-5 w-5 text-sky-700" /><h2 className="font-display text-lg font-bold flex-1">Demandes d'absence des agents</h2>
        {FILTERS.map(([k, l]) => <button key={k} onClick={() => setF(k)} data-testid={`requests-filter-${k.split(",")[0]}`} className={`px-3 py-1.5 rounded-md text-xs font-bold ${f === k ? "bg-slate-900 text-white" : "border border-slate-300"}`}>{l}</button>)}
      </div>
      <UnassignedNotice items={un} onClose={() => setUn(null)} />
      {err && <p className="text-sm text-rose-700 bg-rose-50 border border-rose-200 rounded-md px-4 py-2" data-testid="requests-error">{err} <button onClick={load} className="underline font-semibold">Réessayer</button></p>}
      {err ? null : items === null ? <p className="text-sm text-slate-500">Chargement…</p> : items.length === 0
        ? <p className="text-sm text-slate-500 bg-white border border-slate-200 rounded-md px-4 py-6 text-center" data-testid="requests-empty">{f === "pending" ? "Aucune demande en attente." : "Aucune demande traitée."}</p>
        : <ul className="bg-white border border-slate-200 rounded-md divide-y">{items.map((a) => (
          <li key={a.id} className="px-4 py-3 space-y-1" data-testid={`request-${a.id}`}>
            <div className="flex flex-wrap items-center gap-2 text-sm">
              <b>{a.agent_name}</b><span>{a.label} du {frd(a.start)} au {frd(a.end)} · {a.day_count} j{a.hours ? ` · ${String(a.hours).replace(".", ",")} h` : ""}</span><AbsStatus s={a.status} id={a.id} />
              <span className="text-[11px] text-slate-500">{a.source === "agent" ? "demandée par l'agent" : "saisie par l'administration"} le {new Date(a.created_at).toLocaleDateString("fr-FR")}</span>
              {a.attachment && <button onClick={() => openAbsenceFile(a.id)} className="text-xs text-sky-700 inline-flex items-center gap-1" data-testid={`request-file-${a.id}`}><Paperclip className="h-3 w-3" />{a.attachment.name}</button>}
              <span className="ml-auto"><AbsenceActions a={a} onDone={(u) => { setUn(u || null); load(); }} /></span>
            </div>
            {a.note && <div className="text-xs text-slate-600">« {a.note} »</div>}
            <details className="text-[11px] text-slate-500"><summary className="cursor-pointer inline-flex items-center gap-1"><History className="h-3 w-3" />Historique</summary>
              <ul className="mt-1 space-y-0.5">{(a.history || []).map((h, i) => <li key={i}>{new Date(h.at).toLocaleString("fr-FR")} — {ABS_ACTIONS[h.action] || h.action} par {h.by}{h.note ? ` : ${h.note}` : ""}</li>)}</ul></details>
          </li>
        ))}</ul>}
    </div>
  );
};
